import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './BottomNav.css';

const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: '/', icon: '🏠', label: '首页' },
    { path: '/brands', icon: '📦', label: '品牌' },
    { path: '/messages', icon: '💬', label: '消息' },
    { path: '/cart', icon: '🛒', label: '购物车' },
    { path: '/profile', icon: '👤', label: '我的' },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="bottom-nav">
      {navItems.map((item) => (
        <div
          key={item.path}
          className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
        >
          <div className="nav-icon">{item.icon}</div>
          <div className="nav-text">{item.label}</div>
        </div>
      ))}
    </div>
  );
};

export default BottomNav;
